<div class="dialog__footer">
  <ino-button
    id="cancelButton"
    role="button"
    type="button"
    [attr.aria-label]="cancelText"
    variant="outlined"
    (click)="cancelDialog()">
    {{ cancelText }}
  </ino-button>
  <ino-button
    id="submitButton"
    [type]="submitType"
    role="button"
    variant="filled"
    [attr.aria-label]="submitText"
    (click)="submitType === 'button' && submitDialog()"
    [disabled]="disableSubmit"
    [loading]="isLoading"
    data-testid="submit-button-dialog">
    {{ submitText }}
  </ino-button>
</div>
